import { ChangeDetectionStrategy, Component, inject, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { ENV_CONFIG, EnvConfig } from '@core';
import { getNewVersionWebAndroid, getNewVersionWebiOS } from '@update';

@Component({
  selector: 'lib-blocked-web-view',
  templateUrl: './blocked-web-view.component.html',
  styleUrls: ['./blocked-web-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class BlockedWebViewComponent {
  private readonly env: EnvConfig = inject(ENV_CONFIG);

  readonly path: InputSignal<string> = input.required<string>();

  readonly isPopupVisible: WritableSignal<boolean> = signal<boolean>(false);

  redirectToNativeApp(): void {
    const sharedUrl: string = `${this.env.customUrl}/${this.path()}`;
    const defaultUrl: string = `${this.env.customUrl}`;

    const url: string = this.path() ? sharedUrl : defaultUrl;
    window.open(url, '_blank');
    this.isPopupVisible.set(true);
  }

  downloadAndroid(): void {
    getNewVersionWebAndroid(this.env);
  }

  downloadiOS(): void {
    getNewVersionWebiOS(this.env);
  }
}
